import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { BreadcrumbNav } from "components/molecules";
import { Source } from "utils/constant";
import Wilayah from "services/Wilayah";
import Fasyankes from "services/Fasyankes";
import Laporan from "services/Laporan";
import TableComponent from "./Table";
import FilterSection from "../UjiSilang/Filter";
import { generateLevelUjiSilangOptions } from "utils/helpers";
import LoadingSpinner from "components/LoadingSpinner";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const LaporanService = new Laporan();

const DetailLaporan = () => {
  const module = "Rekap Uji Silang";
  const { currentUser } = useSelector((state) => state.authReducer);
  const history = useHistory();
  const tableRef = useRef(null);

  const [reportData, setReportData] = useState([]);
  const [showFilter, setShowFilter] = useState(true);
  const [showData, setShowData] = useState(false);
  const [levelData, setLevelData] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(currentUser.level);
  const [currentLevel, setCurrentLevel] = useState("");
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
  });
  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );
  const [selectedFasyankes, setSelectedFasyankes] = useState(
    currentUser?.fasyankes_id
  );
  const [periodeLaporan, setPeriodeLaporan] = useState("");
  const [periodeLaporanValue, setPeriodeLaporanValue] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [reportInfo, setReportInfo] = useState({});

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prev) => ({
        ...prev,
        provinces: response.province.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });
      setLevelDataOptions((prev) => ({
        ...prev,
        districts: response.district.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
      });
      setLevelDataOptions((prev) => ({
        ...prev,
        fasyankes: response.fasyankes.map((item) => ({
          label: item.name,
          value: `${item.id}|${item.name}`,
        })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAllProvincies();
    if (selectedProvince)
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    if (selectedDistrict)
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
  }, [selectedProvince, selectedDistrict]);

  useEffect(() => {
    setLevelData(generateLevelUjiSilangOptions(currentUser?.level));
  }, [currentUser]);

  const handleApplyFilter = async () => {
    setIsLoading(true);
    setShowData(false);

    const params = {
      level: selectedLevel,
      level_id: levelIdValue,
      period: periodeLaporan,
      ...periodeLaporanValue,
    };

    try {
      const response = await LaporanService.UjiSilangRekap(params);
      setReportInfo({
        statusPeriode: periodeLaporan,
        periode: periodeLaporanValue,
        province: selectedProvince,
        district: selectedDistrict,
        fasyankes: selectedFasyankes,
      });
      setReportData(response);
      setCurrentLevel(params.level);
    } catch (error) {
      console.log(error);
      setReportData([]);
    } finally {
      setIsLoading(false);
      setShowData(true);
    }
  };

  return (
    <div className="dashboard-wrapper">
      <BreadcrumbNav
        items={[
          { label: "Laporan", onClick: () => history.push("/laporan") },
          { label: module },
        ]}
      />
      <FilterSection
        currentUser={currentUser}
        periodeLaporan={periodeLaporan}
        setPeriodeLaporan={setPeriodeLaporan}
        periodeLaporanValue={periodeLaporanValue}
        setPeriodeLaporanValue={setPeriodeLaporanValue}
        selectedLevel={selectedLevel}
        setSelectedLevel={setSelectedLevel}
        levelData={levelData}
        levelDataOptions={levelDataOptions}
        setLevelIdValue={setLevelIdValue}
        selectedProvince={selectedProvince}
        setSelectedProvince={setSelectedProvince}
        selectedDistrict={selectedDistrict}
        setSelectedDistrict={setSelectedDistrict}
        selectedFasyankes={selectedFasyankes}
        setSelectedFasyankes={setSelectedFasyankes}
        handleApplyFilter={handleApplyFilter}
        tableRef={tableRef}
        showData={showData}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        levelIdValue={levelIdValue}
        reportName="LAPORAN_VERIFIKASI_UJI_SILANG"
      />
      {isLoading && !showData && <LoadingSpinner />}
      {showData && (
        <div className="table-container">
          <div className="data-title">
            <h2>{module}</h2>
          </div>
          <div className="data-main">
            <TableComponent
              currentLevel={currentLevel}
              reportsData={reportData}
              tableRef={tableRef}
              reportInfo={reportInfo}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailLaporan;
